module.exports = __webpack_public_path__ + "img/art-and-design.56a6669c.svg";